import ProductIdentity from '../ProductIdentity';
import React from 'react';
import api from '../../api';

function QuestionsTab({ questions, products = [], answerText, setAnswerText, loadQuestions }) {
  const handleAnswerQuestion = async (questionId) => {
    if (!answerText.trim()) return;
    try {
      await api.patch(`/api/products/questions/${questionId}/answer`, { answer: answerText });
      alert('Ответ сохранён');
      setAnswerText('');
      loadQuestions();
    } catch (err) {
      alert('Ошибка при сохранении ответа');
    }
  };

  return (
    <div>
      <h2 style={{ fontWeight: 700, color: '#1e293b', marginBottom: 20 }}>Вопросы покупателей</h2>
      {questions.length === 0 && <p>Вопросов пока нет.</p>}
      {questions.map(q => (
        <div key={q.id} style={{ background: 'white', borderRadius: 12, padding: 20, marginBottom: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
          <ProductIdentity product={{ ...q, product: q.product || products.find(p => p.id === (q.productId ?? q.product_id)) }} title={q.product_title} sku={q.platform_sku} />
          <p><strong>Покупатель:</strong> {q.customer_name} ({q.customer_phone})</p>
          <p>{q.text}</p>
          {q.answer ? (
            <p><strong>Ответ:</strong> {q.answer}</p>
          ) : (
            <div style={{ marginTop: 10 }}>
              <textarea placeholder="Ваш ответ" value={answerText} onChange={e => setAnswerText(e.target.value)}
                style={{ width: '100%', padding: 8, borderRadius: 8, border: '1px solid #e2e8f0', marginBottom: 8 }} />
              <button onClick={() => handleAnswerQuestion(q.id)} className="btn btn-primary" style={{ padding: '6px 16px' }}>Ответить</button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default QuestionsTab;